import {Breadcrumbs, Typography} from "@mui/material";
import {Link, useParams} from "react-router-dom";
import {getAllFolders} from "../../../lib/services/drive";
import {useEffect, useState} from "react";

const FoldersBreadCrumb = () => {

    const [currentFolder, setCurrentFolder] = useState();
    const [parentFolders, setParentFolders] = useState([]);

    const {folderId} = useParams();
    const getData = async () => {
        getAllFolders().then(payload => {
            const current = payload.find(i => i.id === parseInt(folderId));
            setCurrentFolder(current);
            let newData = [];
            function getParentFolders(data) {
                if (data && data.parentId) {
                    const parent = payload.find(i => i.id === data.parentId)
                    if (parent) {
                        newData.unshift(parent);
                        getParentFolders(parent);
                    }
                }
                return newData;
            }
            setParentFolders(getParentFolders(current));
        });
    }

    useEffect(() => {
        getData();
    }, [folderId]);

    return (
        <Breadcrumbs>
            <Link underline="hover" color="inherit" to="/drive">
                پوشه اصلی
            </Link>
            {parentFolders.length && (
                parentFolders.map((p, index) => (
                    <Link key={index} underline="hover" color="inherit" to={`/drive/${p.id}`}>{p.name}</Link>
                ))
            )}
            {currentFolder && <Typography color="text.primary">{currentFolder.name}</Typography>}
        </Breadcrumbs>
    )
}
export default FoldersBreadCrumb;